import { render } from "./Trends.vue?vue&type=template&id=4f1e49b8&scoped=true"
import script from "./Trends.vue?vue&type=script&lang=js"
export * from "./Trends.vue?vue&type=script&lang=js"

import "@/assets/css/topicContent.sass?vue&type=style&index=0&id=4f1e49b8&lang=sass&scoped=true"
import "./Trends.vue?vue&type=style&index=1&id=4f1e49b8&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1e49b8"]])

export default __exports__